import Startpage from "./Startpage";
import About from "./About";
import Pictures from "./Pictures";
import Cards from "./Cards";
import Contact from "./Contact";
import wrestlers from '../../img/greek-wrestlers-wreath.svg';
import submission from '../../img/greek-submission-wreath.svg';
import fighters from '../../img/greek-punch-wreath.svg';
import kick from '../../img/greek-kick-wreath.svg';
import weightlifter from '../../img/weight-lifter-wreath.svg';
import wreath from '../../img/forca-krans.svg';
import Rules from "./Rules";
import Personal from "./Personal";
import Schedule from './Schedule';
import Prices from "./Prices";


interface ClubContact {
    club: string,
    mail: string,
    tel: string,
    altTel: string,
    address: string
}
interface ICard {
    name: string,
    img: string,
    text: string
}
interface Props {
    contactInfo: ClubContact[]
}
interface Activity {
    day: string,
    time: string,
    type: string,
    room: string,
    grade: string,
    key: number
}
interface ClubContact {
    club: string,
    mail: string,
    tel: string,
    altTel: string,
    address: string
}
interface IPrice {
    article: string,
    price: string,
}
interface Props {
    contactInfo: ClubContact[],
}
const Main = (props: Props) => {

    const styles:ICard[] = [
        {name: "SUBMISSION WRESTLING", img: submission, text: "Submission wrestling, även kallad grappling, är en mix av sporterna judo, brottning och brasiliansk jiu jitsu. Denna träningsform passar dig som vill lära dig fristilsbrottning med låsningar, kast och svep."},
        {name: "MMA", img: fighters, text: "MMA står för Mixed Martial Arts. Kampsporten grundades för att kunna utse den bästa kampsportsstilen i världen genom att låta utövare av olika kamsportsstilar möta varandra. Idag är det sporten mer som namnet antyder, en blandning av många olika kampsportsstilar. Inom MMA:n är det tillåtet att använda de flesta tekniker för att vinna över sin motståndare."},
        {name: "THAIBOXNING", img: kick, text: "Thaiboxning har sitt ursprung i Thailand och har utövats i Sverige sedan sent 70-tal. Inom thaiboxningen är det tillåtet att använda sig av tekniker som slag, sparkar, knän och armbågar."},
        {name: "BROTTNING", img: wrestlers, text: "Fristilsbrottningen har anor som sträcker sig hundratals år bakåt i historien. Skillnaden mellan fristilsbrottning och den grek-romerska brottningen är att grepp över hela kroppen tillåtet i fristilsbrottning."},
        {name: "STYRKETRÄNING", img: weightlifter, text: "I Forca Fightings alla lokaler finns fria vikter som alla medlemmar har tillgång till under träningarna. Träningar i alla stilar innefattar också en stor mängd styrketräning."}
    ];
    const trainers:ICard[] = [
        {name: "Visar Kelmendi", img: wreath, text: "Den yngre brodern av de två grundarna av Forca fighting MMA. Med över 20 års erfarenhet av MMA har han varit delaktig i att ta fram många framgångsrika svenska mästare, landslags- och professionella utövare."},
        {name: "Sadri Kelmendi", img: wreath, text: "Den äldre brodern av de två grundarna av Forca fighting MMA. Även Sadri har över 20 års erfarenhet av MMA och har tillsammans med brorsan varit delaktig i att ta fram många framgångsrika svenska mästare, landslags- och professionella utövare."},
        {name: "Martin Sjunnestrand", img: wreath, text: "Tidigare svensk mästare i shootfighting. Martin har över 10 års erfarenhet som tränare på Forca fighting MMA."},
        {name: "Camilo Laserna Vargas", img: wreath, text: "Camilo har tidigare erfarenhet av ledarroller inom AIK:s ungdomsfotboll. Han är utbildad MMA-tränare och har varit delaktig i Forca fighting i över 3 år. Camillo är även far till vår framtida stjärna Gabriel Laserna."},
        {name: "Bartosz Wójcikiewicz", img: wreath, text: "Forca fightings stora stjärna som ni kommer se mycket mer av framöver på den internationella scenen. Bartosz håller i MMA-träningarna på Forca fighting Solna."},
        {name: "Gabriel Laserna", img: wreath, text: "Gabriel är svensk mästare i MMA och Forca fightings framtida stjärna. Gabriel är även han utbildad MMA-tränare. Gabriel håller thaiboxning för nybörjare och motionärer på Forca Fighting Solna."},
        
    ]

    const summerDays: string[] = ["Mån", "Ons", "Fre"];
    const days: string[] = ["Mån", "Ons", "Fre", "Lör", "Sön"];
    const activities: Activity[] = [
        {day: "Mån", time: "19.30-20.45", type: "SW*/MMA**", room: "", grade: "Nybörjare", key: 1},
        {day: "Mån", time: "20.00-21.30", type: "SW*/MMA**", room: "", grade: "Avancerad", key: 2},
        {day: "Ons", time: "19.30-20.45", type: "SW*/Brottning", room: "", grade: "Nybörjare", key: 3},
        {day: "Ons", time: "20.00-21.30", type: "SW*/Brottning", room: "", grade: "Avancerad", key: 4},
        {day: "Fre", time: "18.00-19.30", type: "Thaiboxning", room: "", grade: "Nybörjare", key: 5},
        {day: "Fre", time: "19.30-21.00", type: "Thaiboxning", room: "", grade: "Avancerad", key: 6},
        {day: "Lör", time: "13.00-14.15", type: "Brottning", room: "", grade: "Barnträning 7-13 år", key: 7},
        {day: "Lör", time: "15.00-16.30", type: "Boxning", room: "", grade: "Blandat", key: 8},
        {day: "Sön", time: "12.00-13.30", type: "MMA**", room: "", grade: "Nybörjare", key: 9},
        {day: "Sön", time: "13.30-15.00", type: "MMA**", room: "", grade: "Avancerad", key: 10},
    ];
    const summarActivities: Activity[] = [
        {day: "Mån", time: "19.30-21.00", type: "SW*/Brottning", room: "", grade: "", key: 1},
        {day: "Ons", time: "19.00-20.30", type: "SW*/Brottning", room: "", grade: "", key: 3},
        {day: "Fre", time: "19.00-20.30", type: "Boxning/Thaiboxning", room: "", grade: "", key: 5},
    ];
    const prices: IPrice[] = [
        {article: "Provträning en gång", price: "100"},
        {article: "Terminsavgift", price: "2400"},
        {article: "Terminsavgift barn", price: "1200"},
        {article: "Månadsträning", price: "950"},
        {article: "Årskort", price: "5000"},
        {article: "Träning 1 gång", price: "180"},
        {article: "Klippkort 10ggr", price: "1500"},
        {article: "Grupp svensexa/kickoff", price: "2000"},
        {article: "Privatlektion 1 person medlem", price: "500"},
        {article: "Privatlektion 2 personer medlemmar", price: "700"},
        {article: "Privatlektion 3-10 personer medlemmar", price: "1000"},
        {article: "Privatlektion 1 person icke medlem", price: "700"},
        {article: "Privatlektion 2 personer icke medlemmar", price: "1000"},
        {article: "Privatlektion 3-10 personer icke medlemmar", price: "1500"},
    ];
    return (
        <>
            <Startpage/>
            <About/>
            {/* <Pictures/> */}
            <Cards id="styles" cards={styles} heading="STILAR"/>
            <Schedule days={days} activities={activities} ursvik={false} header="Höstterminen 2026" info="Gäller fr.o.m. 24/8"/>
            <Prices prices={prices} ursvik={false}/>
            <Personal/>
            <Cards id="trainers" cards={trainers} heading="TRÄNARE"/>
            <Rules/>
            <Contact contactInfo={props.contactInfo} club="both"/>
        </>
    );
};

export default Main;